import { useTranslation } from 'react-i18next';
import { PLAYER_RADAR_TEMPLATES } from '@/consts/radar';
import { PlayerRadarChart } from '../../player/radar/PlayerRadarChart';
import RadarTemplateDropdown from '../../radar/RadarTemplateDropdown';
import { RadarTable } from '../../radar/table/RadarTable';

export const PlayerPreviewBody = () => {
  const { t } = useTranslation(['radar', 'entity']);
  const label = t('dropdownLabel', { entity: t('player.one', { ns: 'entity' }) });

  return (
    <div className="lg:max-w-[600px] flex flex-col relative p-4 gap-4">
      <RadarTemplateDropdown templates={PLAYER_RADAR_TEMPLATES} label={label} />
      <div className="[&>article_div]:p-0">
        <PlayerRadarChart id="player-preview-radar" isInteractive={false} />
      </div>
      <div className="overflow-x-auto border border-canvas-primary-main [&>table]:border-0">
        <RadarTable isInteractive={false} />
      </div>
    </div>
  );
};
